module.exports = __webpack_public_path__ + "static/media/Endurance.401c5733.jpg";